import "./CanvasCut.scss";
const CanvasCut = (props) => {
    let size = props.sizeImage;
    let typeGrid = props.dataType == "grid" ? props.grid : 1;
    const onHandlerSplice = () => {
        console.log(props.grid);
        let massUrl = [];
        for (let i = 0; i < props.grid; i++) {
            for (let j = 0; j < typeGrid; j++) {
                let canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                canvas.width = size.w;
                canvas.height = size.h;
                const image = new Image(size.w / props.grid, size.h / typeGrid);
                image.src = props.urlImage;
                image.onload = () => {
                    context.drawImage(
                        image,
                        (canvas.width / props.grid) * i,
                        (canvas.height / typeGrid) * j,
                        canvas.width / props.grid,
                        canvas.height / typeGrid,
                        0,
                        0,
                        canvas.width / props.grid,
                        canvas.height / typeGrid
                    );
                    let canvas2 = document.createElement("canvas");
                    const context2 = canvas2.getContext("2d");
                    canvas2.width = size.w / props.grid;
                    canvas2.height = size.h / typeGrid;
                    context2.drawImage(canvas, 0, 0);
                    const dataSrc = canvas2.toDataURL();
                    massUrl.push(dataSrc);
                };
            }
        }
        setTimeout(() => {
            props.dataArr(massUrl);
        }, 1000);
    };

    return (
        <div className="cut-btn-wrapper">
            <button className="cut-btn btn" onClick={onHandlerSplice}>
                {" "}
                splice{" "}
            </button>
        </div>
    );
};

export default CanvasCut;
